export default __webpack_public_path__ + "static/media/ofi_logo_dark.f108c5aa.png";